export interface InputNumberComponentConfig {
  step?: number | string;
  max?: number;
  min?: number;
  cssStyle?: { [key: string]: any };
  cssClass?: string;
  disabled?: boolean;
}
